const ACCESS_TOKEN_KEY = "auth.access_token";
const REFRESH_TOKEN_KEY = "auth.refresh_token";

function getStorage() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.localStorage;
}

export function getAccessToken() {
  return getStorage()?.getItem(ACCESS_TOKEN_KEY) || null;
}

export function getRefreshToken() {
  return getStorage()?.getItem(REFRESH_TOKEN_KEY) || null;
}

export function getTokens() {
  return {
    access: getAccessToken(),
    refresh: getRefreshToken(),
  };
}

export function setTokens({ access, refresh }) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  if (typeof access === "string" && access.length > 0) {
    storage.setItem(ACCESS_TOKEN_KEY, access);
  }
  if (typeof refresh === "string" && refresh.length > 0) {
    storage.setItem(REFRESH_TOKEN_KEY, refresh);
  }
}

export function clearTokens() {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(ACCESS_TOKEN_KEY);
  storage.removeItem(REFRESH_TOKEN_KEY);
}

export const tokenStore = {
  getAccessToken,
  getRefreshToken,
  getTokens,
  setTokens,
  clearTokens,
};
